import type { DragEvent } from 'react';
import { useSimulationStore } from '../../../store/simulationStore';
import type { DistributionConfig } from '../../../models/simulation';
import { AddInputMenu, type AddInputKind } from './AddInputMenu';

const defaultDistribution = (name: string): DistributionConfig => ({
  kind: 'normal',
  mean: 100,
  std: 10,
  min: 0,
  max: 200,
  label: name
});

export const NodePalette = () => {
  const addNode = useSimulationStore((state) => state.addNode);

  const addDistribution = () =>
    addNode(
      {
        type: 'distribution',
        name: 'Input variable',
        description: 'Uncertain model driver',
        config: defaultDistribution('Input variable')
      },
      { x: 150, y: 150 }
    );

  const addFormula = () =>
    addNode(
      {
        type: 'formula',
        name: 'Formula driver',
        description: 'Expression referencing inputs',
        expression: ''
      },
      { x: 400, y: 150 }
    );

  const onDragStart = (event: DragEvent<HTMLButtonElement>, nodeType: AddInputKind) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="palette-panel" aria-label="Add nodes">
      <div className="palette-items">
        <AddInputMenu
          className="palette-add-input-menu"
          onAddDistribution={addDistribution}
          onAddFormula={addFormula}
          onOptionDragStart={onDragStart}
        />
      </div>
    </div>
  );
};
